import * as types from './mutation-types'
import { getClientsResumes, getTypesClient } from '../../../api/client'

const getInitialState = () => {
  return {
    clients: {},
    typesClient: {}
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_CLIENTS](state, clients) {
    state.clients = clients
  },
  [types.SET_TYPES_CLIENTS](state, typesClient) {
    state.typesClient = typesClient
  }
}

const actions = {
  async getClients({ commit }) {
    const clients = await getClientsResumes()
    commit(types.SET_CLIENTS, clients)
  },
  async getTypesClient({ commit }) {
    const typesClient = await getTypesClient()
    commit(types.SET_TYPES_CLIENTS, typesClient)
  }
}

const getters = {
  clients: state => state.clients,
  typesClient: state => state.typesClient
}

export default { state, mutations, actions, getters }
